



















































































import Vue from 'vue';
import {StoreMutation} from '@/store/mutations';
import {RoutsData} from '@/router/routs';

export default Vue.extend({
  data() {
    return {
      items: [{
        title: 'Выйти'
      }]
    }
  },
  computed: {
    isAppBarHidden(): boolean {
      return this.$store.getters.currentUser == undefined;
    }
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$store.commit('clearState');
      this.$router.push({name: RoutsData.LOGIN.name})
    }
  }
});
